
//系统目录 / 西药 接口相关的函数
import request from "@/untils/request.js"

/**
 * 
 *  post
 *  
 */

//登录函数
export const login = (data) => {
    return request.post("/outpatient/login",data)
}

//新建西成药目录
export const addDrugInformation = (data) => {
    return request.post("/outpatient/addDrugInformation",data)
}

//新建药典目录
export const addDrugs = (data) => {
    return request.post("/outpatient/addDrugs",data)
}

//修改西成药目录
export const updateDrugInformation = (data) => {
    return request.post("/outpatient/updateDrugInformation",data)
}
//修改中药目录
export const UpdateTraMedici = (data) => {
    return request.post("/outpatient/traMedici/updatedTra", data)
}

export const addDocTDrugCode = (data) => {
    return request.post("/outpatient/addDocTDrugCode",data)
}

// Excel导入接口 - 关键修改：移除手动设置的 Content-Type
export function importExcel(formData, config = {}) {
  return request({
    url: '/outpatient/importWmDrug',
    method: 'post',
    data: formData,
    // 重要：不要手动设置Content-Type，让浏览器自动设置boundary
    headers: {
      ...config.headers,
      'Content-Type': undefined // 让浏览器自动设置
    },
    timeout: 60000,
    ...config
  })
}
// 中药Excel导入接口 - 关键修改：移除手动设置的 Content-Type
export function importZYExcel(formData, config = {}) {
  return request({
    url: '/outpatient/traMedici/import',
    method: 'post',
    data: formData,
    // 重要：不要手动设置Content-Type，让浏览器自动设置boundary
    headers: {
      ...config.headers,
      'Content-Type': undefined // 让浏览器自动设置
    },
    timeout: 60000,
    ...config
  })
}
/**
 * 
 * get 
 *  
 */

// 西药目录信息导出
export const exportAllWmDrug = (params) => {
    return request.get("/outpatient/exportAllWmDrug", {params,responseType: 'blob'})
}
// 中药目录信息导出
export const exportAllZYWmDrug = (params) => {
    return request.get("/outpatient/traMedici/exportAllTcmDrug", {params,responseType: 'blob'})
}
// 树菜单
export const AllTree = (params) => {
    return request.get("/outpatient/selectAllDrugCategory", { params })
}

// 本位码
export const ProductNameCode = (params) => {
    return request.get("/outpatient/selectByProductName", { params })
}

// 通过树形结构为参数比如点击西药就查出西药的数据查询对应的数据
export const getDrugType = (params) => {
    return request.get("/outpatient/getDrugType", { params })
}

// 公共目录的树形结构 （药品类型）
export const selectCateGory = (params) => {
    return request.get("/outpatient/selectCateGory", { params })
}

// 点击树形结构查询对应数据
export const getTreeData = (params) => {
    return request.get("/outpatient/getTreeData", { params })
}

// 药物类别
export const selectOneCateGory = (params) => {
    return request.get("/outpatient/selectOneCateGory", { params })
}

// 药物类别2级分类 药理子类别
export const selectTwoCateGory = (params) => {
    return request.get("/outpatient/selectTwoCateGory", { params })
}

// 药物类别3级分类 药理3子类别
export const selectThreeCateGory = (params) => {
    return request.get("/outpatient/selectThreeCateGory", { params })
}

// 列表，带条件查询，带分页  => 剂型
export const selectDrugDosageForm = (params) => {
    return request.get("/outpatient/selectDrugDosageForm", { params })
}

// 毒麻类型 all
export const selectDocVtByType = (params) => {
    return request.get("/outpatient/selectDocVtByType", { params })
}

//病案费别
export const getRecordCategory = (params) => {
    return request.get("/outpatient/getRecordCategory", { params })
}

// 药典目录列表
export const selectDrugCatalogue = (params) => {
    return request.get("/outpatient/selectDrugCatalogue", { params })
}

// 西成药目录列表，带分页查询，和条件查询
export const getDrugList = (params) => {
    return request.get("/outpatient/getDrugList", { params })
}
// 中药列表 
export const traMediciList = (params) => {
    return request.get("/outpatient/traMedici/page", { params })
}

// 西药药品剂型
export const getDosageForm = (params) => {
    return request.get("/outpatient/selectDrugDosageForm", { params })
}
// 修改西药指定售价
export const UpdateFixPric = (params) => {
    return request.get("/outpatient/updateFixPric", { params })
}
// 修改中药指定售价
export const updateZYFixPric = (params) => {
    return request.get("/outpatient/traMedici/updateTcmFixPric", { params })
}
// 查用于新建西城药目录的 药典名称模糊查询
export const selectByDrugCatalogue = (params) => {
    return request.get("/outpatient/selectByDrugCatalogue", { params })
}

// 该查询是西成药信息用于修改回填数据
export const getDInfos = (params) => {
    return request.get("/outpatient/getDInfos", { params })
}
// 该查询是中药信息用于修改回填数据
export const getTraMedic = (params) => {
    return request.get("/outpatient/traMedici/getTraMedic", { params })
}


// 获取厂家信息
export const getManufacturer = (params) => {
    return request.get("/outpatient/getManufacturer", { params })
}

// 改查西成药厂家信息用于修改回填数据
export const getDrugManufacturer = (params) => {
    return request.get("/outpatient/getDrugManufacturer", { params })
}
// 新增药品基础信息-查询加成率
export const docMarkById = (params) => {
    return request.get("/outpatient/docMark/getById", { params })
}
// 西药档案删除
export const deleteDrugP = (params) => {
    return request.get("/outpatient/deleteDrugP", { params })
}
// 中药目录列表删除
export const deleteTP = (params) => {
    return request.get("/outpatient/traMedici/deleteTP", { params })
}
/**
 * 
 * DELETE 
 *  
 */   


// 暴露
export default{
AllTree,getTreeData,importExcel,exportAllWmDrug,importZYExcel,
ProductNameCode,getDrugType,selectDrugCatalogue,selectOneCateGory,selectTwoCateGory,selectThreeCateGory,addDrugs,deleteDrugP,getDInfos,
selectDrugDosageForm,
selectDocVtByType,getRecordCategory,
getDrugList,docMarkById,
selectByDrugCatalogue,addDrugInformation,updateDrugInformation,
getManufacturer,getDrugManufacturer,addDocTDrugCode
}